import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import Image from 'components/Common/Image'

const TileResponsiveImage = styled(ResponsiveImage)`
  grid-column: 1 / -1;
  grid-row: 1 / -1;
`

const TileImage = styled(Image)`
  grid-column: 1 / -1;
  grid-row: 1 / -1;
`

interface Props {
  image?: {
    url?: string
    id?: string
    title?: string
  }
}

function CartReviewTileImageContent({ image }: Props) {
  if (!image) return null

  return (
    <>
      {image.url && (
        <TileImage
          image={image}
          fit="center"
        />
      )}
      {image.id && !image.url && (
        <TileResponsiveImage
          id={image.id}
          alt={image.title}
          role="presentation"
          fit="center"
          width={rem(64)}
          tabletWidth={rem(190)}
        />
      )}
    </>
  )
}

export default CartReviewTileImageContent
